var paywall = require("./lib/paywall");
setTimeout(() => paywall(13239102), 5000);

const $ = require('jquery');


require("component-responsive-frame/child");

if ($(window).width() < 700) {
   $('.desktop').hide();
   $('.mobile').show();

   document.querySelectorAll('.box').forEach(el => {
      var boxNumber = el.dataset.num;
      var conSet = el.parentNode.dataset.set;
      var findExpand = document.querySelector(`.expandContainer[data-set="${conSet}"]`);
      var theRightExpand = findExpand.querySelector(`.expand[data-num="${boxNumber}"]`);
      el.after(theRightExpand);
  });
} else {
  $('.desktop').show();
  $('.mobile').hide();
}



$( ".box" ).click(function() {
  var number = $(this).data("num");
  var set = $(this).closest('.container').data("set");
  var expandCon = $(this).closest('.container');


  if ( $(this).hasClass("selected") ) {

    expandCon.find(`.expand[data-num="${number}"]`).hide();
    $(this).removeClass('selected');
    $(this).find('.chevs').removeClass('selected');

    // if ($(window).width() >= 700) {
    //   $(this).closest('.container').find('.box').removeClass('highlightRow');
    // }
  } else {
    // if ($(window).width() >= 700) {
    //   // expandCon.find('.expand').hide();
    //   $(this).removeClass('selected');
    //   $(this).find('.chevs').removeClass('selected');
    //   // $(this).closest('.container').find('.box').addClass('highlightRow');
    // }

    $(this).addClass('selected');
    $(this).find('.chevs').addClass('selected');
    // $('#data-page').find(`.expandContainer[data-set="${set}"]`).css("color","red");
    expandCon.find(`.expand[data-num="${number}"]`).show();
  }
});

$( ".collapse" ).click(function() {
  var number = $(this).closest('.expand').data("num");
  // var set = $(this).closest('.container').data("set");
  var expandCon = $(this).closest('.container');


  expandCon.find(`.expand[data-num="${number}"]`).hide();
  expandCon.find(`.box[data-num="${number}"]`).removeClass('selected');
  expandCon.find(`.box[data-num="${number}"] .chevs`).removeClass('selected');

  $('html, body').animate({
    scrollTop: expandCon.find(`.box[data-num="${number}"]`).offset().top - 20 //#DIV_ID is an example. Use the id of your destination on the page
  }, 'fast');



});



